import { render, staticRenderFns } from "./parsers-form.vue?vue&type=template&id=398aa06c&"
import script from "./parsers-form.vue?vue&type=script&lang=js&"
export * from "./parsers-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports